import React from 'react';
import { Calendar } from 'lucide-react';

// Items 8 & 9 — standardized date range options used across all role
// Insights pages and the Tasks tab.
export const DATE_RANGES = [
  { key: 'all', label: 'All' },
  { key: 'this_week', label: 'This Week' },
  { key: 'this_month', label: 'This Month' },
  { key: 'last_6_months', label: 'Last 6 Months' },
  { key: 'this_year', label: 'This Year' },
  { key: 'custom', label: 'Custom' },
];

// Build the query-string params object the backend expects.
export const rangeParams = (range, from, to) => {
  const p = { range };
  if (range === 'custom') {
    if (from) p.start = from;
    if (to) p.end = to;
  }
  return p;
};

const DateRangeFilter = ({
  value,
  onChange,
  customFrom = '',
  customTo = '',
  onCustomFrom,
  onCustomTo,
  testId = 'date-range-filter',
}) => (
  <div className="bg-white rounded-xl border border-gray-200 p-3 flex flex-wrap items-center gap-3" data-testid={testId}>
    <Calendar size={16} className="text-teal-600" />
    <div className="flex flex-wrap gap-1.5">
      {DATE_RANGES.map((r) => (
        <button
          key={r.key}
          type="button"
          onClick={() => onChange(r.key)}
          data-testid={`${testId}-${r.key}`}
          className={`px-3 py-1.5 text-xs rounded-full border transition-colors ${
            value === r.key
              ? 'bg-teal-600 text-white border-teal-600'
              : 'bg-white text-gray-700 border-gray-200 hover:border-teal-300'
          }`}
        >
          {r.label}
        </button>
      ))}
    </div>
    {value === 'custom' && (
      <div className="flex items-center gap-2 ml-1">
        <input
          type="date"
          value={customFrom}
          onChange={(e) => onCustomFrom?.(e.target.value)}
          className="text-xs px-2 py-1 border border-gray-200 rounded"
          data-testid={`${testId}-from`}
        />
        <span className="text-xs text-gray-500">to</span>
        <input
          type="date"
          value={customTo}
          onChange={(e) => onCustomTo?.(e.target.value)}
          className="text-xs px-2 py-1 border border-gray-200 rounded"
          data-testid={`${testId}-to`}
        />
      </div>
    )}
  </div>
);

export default DateRangeFilter;
